import { Subject } from "rxjs";
import { TicketMutationEvent } from "../types/TicketMutationEvent";

const internalEvent$ = new Subject<TicketMutationEvent>();

/**
 * Emits ticket mutation events after successful user-driven changes or socket live updates.
 */
export const emitTicketMutationEvent = (event: TicketMutationEvent) => {
  internalEvent$.next(event);
};

/**
 * Stream of ticket mutation events used to sync ticket lists and related UI.
 */
export const ticketMutations$ = internalEvent$.asObservable();
